import { useCallback, useEffect, useState } from "react";
import request, { ResponseError } from "superagent";
import useSyncedLocalStorage from "@avinet/adaptive-ui-core/hooks/useSyncedLocalStorage";
import { TranslatorProvider } from "@avinet/adaptive-ui-translate";
import LoginDialog from "./components/LoginDialog";
import { BACKEND_URL, SESSION_TOKEN_KEY } from "./config/config";
import { useBrowserLanguage } from "./hooks/useBrowserLanguage";
import useSessionToken from "./hooks/useSessionToken";
import { MainLayout } from "./layouts/MainLayout";
import { ProfileView } from "./views/ProfileView";
import "./App.scss";

export function App() {
  const lang = useBrowserLanguage();
  const sessionToken = useSessionToken();
  const [loggedIn, setLoggedIn] = useState(true);
  const [loginKey, setLoginKey] = useState(0);
  const [, setSessionToken] = useSyncedLocalStorage(SESSION_TOKEN_KEY);
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    if (!sessionToken) {
      setLoggedIn(false);
      return;
    }

    function load() {
      request
        .get(BACKEND_URL + "api/info/auth/authenticated")
        .set("Authorization", `Bearer ${sessionToken}`)
        .then(() => setLoggedIn(true))
        .catch((err: ResponseError) => {
          if (err.response?.statusCode === 401) {
            setSessionExpired(true);
            setLoggedIn(false);
          }
        });
    }

    const tId = setInterval(load, 60000);
    load();

    return () => {
      clearInterval(tId);
    };
  }, [sessionToken, loginKey]);

  useEffect(() => {
    const tId = setInterval(() => setLoginKey((key) => key + 1), 60000);
    return () => clearInterval(tId);
  }, []);

  const handleLogout = useCallback(() => {
    setSessionExpired(false);
    setLoggedIn(false);
    setSessionToken(null);
  }, [setSessionToken]);

  return (
    <>
      {sessionToken && (
        <TranslatorProvider translations={lang}>
          <MainLayout>
            <ProfileView handleLogout={handleLogout} />
          </MainLayout>
        </TranslatorProvider>
      )}
      {!loggedIn && (
        <TranslatorProvider translations={lang}>
          <LoginDialog sessionExpired={sessionExpired} />
        </TranslatorProvider>
      )}
    </>
  );
}
